module.exports = __webpack_public_path__ + "img/qa.11bc5de1.png";